import type {ActionPlanType} from '@/models/contract'
import {
    ALLMA_JOB_TYPE_ADDITIVE_PLANTING,
    ALLMA_JOB_TYPE_DITCH_CLEARING,
    ALLMA_JOB_TYPE_FERTILIZATION,
    ALLMA_JOB_TYPE_PLANTATION_CONTROL,
    ALLMA_JOB_TYPE_PLANTING,
    ALLMA_JOB_TYPE_PRECLEARING_FELLING,
    ALLMA_JOB_TYPE_PRECLEARING_THINNING,
    ALLMA_JOB_TYPE_SCARIFICATION,
    ALLMA_JOB_TYPE_SCARIFICATION_WITH_EXCAVATOR,
    ALLMA_JOB_TYPE_SCARIFICATION_WITH_SOWING,
    ALLMA_JOB_TYPE_SPRAYING,
    ALLMA_JOB_TYPE_STEMPRUNING,
    ALLMA_JOB_TYPE_YOUNG_TREE_CARE
} from '~/constants/allmaJobs'
import {useProductService} from "~/services/productService";

export const ACTIONPLAN_REALLOCATED_AREA_OPEN = 0
export const ACTIONPLAN_REALLOCATED_AREA_REGULATED = 1
export const ACTIONPLAN_REALLOCATED_AREA_BEITE = 2
export const ACTIONPLAN_REALLOCATED_AREA_NATURAL = 3
export const ACTIONPLAN_REALLOCATED_AREA_THINNING = 4
export const ACTIONPLAN_REALLOCATED_AREA_OTHER = 999

export const ACTIONPLAN_TYPES_SCARIFICATION = 1
export const ACTIONPLAN_TYPES_SCARIFICATION_WITH_EXCAVATOR = 2
export const ACTIONPLAN_TYPES_PLANTING = 3
export const ACTIONPLAN_TYPES_PLANTSALE = 4
export const ACTIONPLAN_TYPES_DITCH_CLEARING = 5
export const ACTIONPLAN_TYPES_SPRAYING = 6
export const ACTIONPLAN_TYPES_PRECLEARING_THINNING = 7
export const ACTIONPLAN_TYPES_PRECLEARING_FELLING = 8
export const ACTIONPLAN_TYPES_ADDITIVE_PLANTING = 9
export const ACTIONPLAN_TYPES_FERTILIZATION = 10
export const ACTIONPLAN_TYPES_YOUNG_TREE_CARE = 11
export const ACTIONPLAN_TYPES_STEMPRUNING = 12
export const ACTIONPLAN_TYPES_PLANTATION_CONTROL = 13
export const ACTIONPLAN_TYPES_SCARIFICATION_WITH_SOWING = 16

export const ACTIONPLAN_PLANTING_MONTHS = [4, 8]
export const ACTIONPLAN_PREVENT_PLANTING_IDS = [ACTIONPLAN_TYPES_ADDITIVE_PLANTING, ACTIONPLAN_TYPES_PLANTSALE]

const ALL_MONTHS = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]

export const ACTIONPLAN_TYPES: ActionPlanType[] = [
  {
    Id: ACTIONPLAN_TYPES_SCARIFICATION,
    Name: 'SCARIFICATION',
    Short: 'MB',
    Field: 'Scarification',
    DateField: 'ScarificationDate',
    Icon: 'spot/scarification',
    TypeOfVolume: 'AREA_DAA',
    checkValue: true,
    allmaJobId: ALLMA_JOB_TYPE_SCARIFICATION,
    excludeFromTypes: [ACTIONPLAN_TYPES_SCARIFICATION_WITH_EXCAVATOR, ACTIONPLAN_TYPES_SCARIFICATION_WITH_SOWING, ACTIONPLAN_TYPES_ADDITIVE_PLANTING, ACTIONPLAN_TYPES_FERTILIZATION, ACTIONPLAN_TYPES_YOUNG_TREE_CARE, ACTIONPLAN_TYPES_STEMPRUNING],
    excludeFromReallocatedAreas: [ACTIONPLAN_REALLOCATED_AREA_REGULATED, ACTIONPLAN_REALLOCATED_AREA_BEITE, ACTIONPLAN_REALLOCATED_AREA_THINNING],
    allowedMonths: [6, 8]
  },
  {
    Id: ACTIONPLAN_TYPES_SCARIFICATION_WITH_SOWING,
    Name: 'SCARIFICATION_WITH_SOWING',
    Short: '',
    Field: 'GroundPreparationwithSowing',
    DateField: 'GroundPreparationwithSowingDate',
    Icon: 'spot/scarification',
    TypeOfVolume: 'AREA_DAA',
    checkValue: true,
    allmaJobId: ALLMA_JOB_TYPE_SCARIFICATION_WITH_SOWING,
    excludeFromTypes: [ACTIONPLAN_TYPES_SCARIFICATION, ACTIONPLAN_TYPES_SCARIFICATION_WITH_EXCAVATOR, ACTIONPLAN_TYPES_ADDITIVE_PLANTING, ACTIONPLAN_TYPES_FERTILIZATION, ACTIONPLAN_TYPES_YOUNG_TREE_CARE, ACTIONPLAN_TYPES_STEMPRUNING],
    excludeFromReallocatedAreas: [ACTIONPLAN_REALLOCATED_AREA_REGULATED, ACTIONPLAN_REALLOCATED_AREA_BEITE, ACTIONPLAN_REALLOCATED_AREA_THINNING],
    allowedMonths: [5, 6, 8]
  },
  {
    Id: ACTIONPLAN_TYPES_SCARIFICATION_WITH_EXCAVATOR,
    Name: 'SCARIFICATION_WITH_EXCAVATOR',
    Short: 'MG',
    Field: 'ScarificationWithExcavator',
    DateField: 'ScarificationWithExcavatorDate',
    Icon: 'spot/excavator',
    TypeOfVolume: 'AREA_DAA',
    checkValue: true,
    allmaJobId: ALLMA_JOB_TYPE_SCARIFICATION_WITH_EXCAVATOR,
    excludeFromTypes: [ACTIONPLAN_TYPES_SCARIFICATION, ACTIONPLAN_TYPES_SCARIFICATION_WITH_SOWING, ACTIONPLAN_TYPES_ADDITIVE_PLANTING, ACTIONPLAN_TYPES_FERTILIZATION, ACTIONPLAN_TYPES_YOUNG_TREE_CARE, ACTIONPLAN_TYPES_STEMPRUNING],
    excludeFromReallocatedAreas: [ACTIONPLAN_REALLOCATED_AREA_REGULATED, ACTIONPLAN_REALLOCATED_AREA_BEITE, ACTIONPLAN_REALLOCATED_AREA_THINNING],
    allowedMonths: [5, 6, 7, 8, 9]
  },
  {
    Id: ACTIONPLAN_TYPES_PLANTING,
    Name: 'PLANTING',
    Short: '',
    Field: 'Planting',
    DateField: 'PlantingDate',
    Icon: 'spot/planting',
    TypeOfVolume: 'AREA_DAA',
    checkValue: 2,
    allmaJobId: ALLMA_JOB_TYPE_PLANTING,
    excludeFromTypes: [],
    excludeFromReallocatedAreas: [],
    allowedMonths: ACTIONPLAN_PLANTING_MONTHS
  },
  {
    Id: ACTIONPLAN_TYPES_PLANTSALE,
    Name: 'PLANTSALE',
    Short: 'PS',
    Field: 'Plantsale',
    DateField: 'PlantingDate',
    Icon: 'spot/plant-sale',
    TypeOfVolume: 'NUMBER_OF_PLANTS_WITH_VOLUME',
    checkValue: true,
    allmaJobId: ALLMA_JOB_TYPE_PLANTING,
    excludeFromTypes: [ACTIONPLAN_TYPES_ADDITIVE_PLANTING, ACTIONPLAN_TYPES_FERTILIZATION, ACTIONPLAN_TYPES_YOUNG_TREE_CARE, ACTIONPLAN_TYPES_STEMPRUNING],
    excludeFromReallocatedAreas: [ACTIONPLAN_REALLOCATED_AREA_REGULATED, ACTIONPLAN_REALLOCATED_AREA_BEITE, ACTIONPLAN_REALLOCATED_AREA_NATURAL, ACTIONPLAN_REALLOCATED_AREA_THINNING],
    allowedMonths: ACTIONPLAN_PLANTING_MONTHS
  },
  {
    Id: ACTIONPLAN_TYPES_PLANTATION_CONTROL,
    Name: 'PLANTATION_CONTROL',
    Short: 'PC',
    Field: 'PlantationControl',
    DateField: 'PlantationControlDate',
    Icon: 'spot/none',
    TypeOfVolume: 'AREA_DAA',
    checkValue: true,
    allmaJobId: ALLMA_JOB_TYPE_PLANTATION_CONTROL,
    excludeFromTypes: [],
    excludeFromReallocatedAreas: [],
    allowedMonths: ALL_MONTHS
  },
  {
    Id: ACTIONPLAN_TYPES_DITCH_CLEARING,
    Name: 'DITCH_CLEARING',
    Short: 'GR',
    Field: 'DitchClearing',
    DateField: 'DitchClearingDate',
    Icon: 'spot/ditch-clearing',
    TypeOfVolume: 'NUMBER_OF_METERS_WITH_VOLUME',
    checkValue: true,
    allmaJobId: ALLMA_JOB_TYPE_DITCH_CLEARING,
    excludeFromTypes: [ACTIONPLAN_TYPES_ADDITIVE_PLANTING, ACTIONPLAN_TYPES_FERTILIZATION, ACTIONPLAN_TYPES_YOUNG_TREE_CARE, ACTIONPLAN_TYPES_STEMPRUNING],
    excludeFromReallocatedAreas: [ACTIONPLAN_REALLOCATED_AREA_REGULATED, ACTIONPLAN_REALLOCATED_AREA_BEITE],
    allowedMonths: ALL_MONTHS
  },
  {
    Id: ACTIONPLAN_TYPES_SPRAYING,
    Name: 'SPRAYING',
    Short: 'SP',
    Field: 'Spraying',
    DateField: 'SprayingDate',
    Icon: 'spot/spraying',
    TypeOfVolume: 'AREA_DAA',
    checkValue: true,
    allmaJobId: ALLMA_JOB_TYPE_SPRAYING,
    excludeFromTypes: [ACTIONPLAN_TYPES_ADDITIVE_PLANTING, ACTIONPLAN_TYPES_FERTILIZATION, ACTIONPLAN_TYPES_YOUNG_TREE_CARE, ACTIONPLAN_TYPES_STEMPRUNING],
    excludeFromReallocatedAreas: [ACTIONPLAN_REALLOCATED_AREA_REGULATED, ACTIONPLAN_REALLOCATED_AREA_BEITE, ACTIONPLAN_REALLOCATED_AREA_NATURAL, ACTIONPLAN_REALLOCATED_AREA_THINNING],
    allowedMonths: ALL_MONTHS
  },
  {
    Id: ACTIONPLAN_TYPES_PRECLEARING_THINNING,
    Name: 'PRECLEARING_THINNING',
    Short: 'FFT',
    Field: 'PreclearingBeforeThinning',
    DateField: 'PreclearingBeforeThinningDate',
    Icon: 'spot/thinning',
    TypeOfVolume: 'AREA_DAA',
    checkValue: true,
    allmaJobId: ALLMA_JOB_TYPE_PRECLEARING_THINNING,
    excludeFromTypes: [],
    excludeFromReallocatedAreas: [ACTIONPLAN_REALLOCATED_AREA_OPEN, ACTIONPLAN_REALLOCATED_AREA_REGULATED, ACTIONPLAN_REALLOCATED_AREA_BEITE, ACTIONPLAN_REALLOCATED_AREA_NATURAL],
    allowedMonths: ALL_MONTHS
  },
  {
    Id: ACTIONPLAN_TYPES_PRECLEARING_FELLING,
    Name: 'PRECLEARING_FELLING',
    Short: 'FFS',
    Field: 'PreclearingBeforeFinalFelling',
    DateField: 'PreclearingBeforeFinalFellingDate',
    Icon: 'spot/pre-clearing',
    TypeOfVolume: 'AREA_DAA',
    checkValue: true,
    allmaJobId: ALLMA_JOB_TYPE_PRECLEARING_FELLING,
    excludeFromTypes: [ACTIONPLAN_TYPES_ADDITIVE_PLANTING, ACTIONPLAN_TYPES_FERTILIZATION, ACTIONPLAN_TYPES_YOUNG_TREE_CARE, ACTIONPLAN_TYPES_STEMPRUNING],
    excludeFromReallocatedAreas: [ACTIONPLAN_REALLOCATED_AREA_THINNING],
    allowedMonths: ALL_MONTHS
  },
  {
    Id: ACTIONPLAN_TYPES_ADDITIVE_PLANTING,
    Name: 'ADDITIVE_PLANTING',
    Short: 'SP',
    Field: 'AdditivePlanting',
    DateField: 'PlantingDate',
    Icon: 'spot/supplementary-planting',
    TypeOfVolume: 'AREA_DAA_NUMBER_OF_PLANTS',
    checkValue: true,
    allmaJobId: ALLMA_JOB_TYPE_ADDITIVE_PLANTING,
    excludeFromTypes: [ACTIONPLAN_TYPES_SCARIFICATION, ACTIONPLAN_TYPES_SCARIFICATION_WITH_EXCAVATOR, ACTIONPLAN_TYPES_PLANTSALE, ACTIONPLAN_TYPES_DITCH_CLEARING, ACTIONPLAN_TYPES_SPRAYING, ACTIONPLAN_TYPES_PRECLEARING_FELLING, ACTIONPLAN_TYPES_FERTILIZATION, ACTIONPLAN_TYPES_YOUNG_TREE_CARE, ACTIONPLAN_TYPES_STEMPRUNING],
    excludeFromReallocatedAreas: [ACTIONPLAN_REALLOCATED_AREA_REGULATED, ACTIONPLAN_REALLOCATED_AREA_BEITE, ACTIONPLAN_REALLOCATED_AREA_NATURAL, ACTIONPLAN_REALLOCATED_AREA_THINNING],
    allowedMonths: ALL_MONTHS
  },
  {
    Id: ACTIONPLAN_TYPES_FERTILIZATION,
    Name: 'FERTILIZATION',
    Short: 'GJ',
    Field: 'Fertilization',
    DateField: 'FertilizationDate',
    Icon: 'spot/fertilizing',
    TypeOfVolume: 'AREA_DAA',
    checkValue: true,
    allmaJobId: ALLMA_JOB_TYPE_FERTILIZATION,
    excludeFromTypes: [ACTIONPLAN_TYPES_SCARIFICATION, ACTIONPLAN_TYPES_SCARIFICATION_WITH_EXCAVATOR, ACTIONPLAN_TYPES_PLANTSALE, ACTIONPLAN_TYPES_DITCH_CLEARING, ACTIONPLAN_TYPES_SPRAYING, ACTIONPLAN_TYPES_PRECLEARING_FELLING, ACTIONPLAN_TYPES_ADDITIVE_PLANTING, ACTIONPLAN_TYPES_YOUNG_TREE_CARE, ACTIONPLAN_TYPES_STEMPRUNING],
    excludeFromReallocatedAreas: [ACTIONPLAN_REALLOCATED_AREA_REGULATED, ACTIONPLAN_REALLOCATED_AREA_BEITE, ACTIONPLAN_REALLOCATED_AREA_NATURAL, ACTIONPLAN_REALLOCATED_AREA_THINNING],
    allowedMonths: ALL_MONTHS
  },
  {
    Id: ACTIONPLAN_TYPES_YOUNG_TREE_CARE,
    Name: 'YOUNG_TREE_CARE',
    Short: 'UP',
    Field: 'YoungTreecare',
    DateField: 'YoungTreecareDate',
    Icon: 'spot/tending',
    TypeOfVolume: 'AREA_DAA',
    checkValue: true,
    allmaJobId: ALLMA_JOB_TYPE_YOUNG_TREE_CARE,
    excludeFromTypes: [ACTIONPLAN_TYPES_SCARIFICATION, ACTIONPLAN_TYPES_SCARIFICATION_WITH_EXCAVATOR, ACTIONPLAN_TYPES_PLANTSALE, ACTIONPLAN_TYPES_DITCH_CLEARING, ACTIONPLAN_TYPES_SPRAYING, ACTIONPLAN_TYPES_PRECLEARING_FELLING, ACTIONPLAN_TYPES_ADDITIVE_PLANTING, ACTIONPLAN_TYPES_FERTILIZATION],
    excludeFromReallocatedAreas: [ACTIONPLAN_REALLOCATED_AREA_REGULATED, ACTIONPLAN_REALLOCATED_AREA_BEITE, ACTIONPLAN_REALLOCATED_AREA_NATURAL, ACTIONPLAN_REALLOCATED_AREA_THINNING],
    allowedMonths: ALL_MONTHS
  },
  {
    Id: ACTIONPLAN_TYPES_STEMPRUNING,
    Name: 'STEMPRUNING',
    Short: 'SK',
    Field: 'Stempruning',
    DateField: 'StempruningDate',
    Icon: 'spot/trunk-limbing',
    TypeOfVolume: 'AREA_DAA',
    checkValue: true,
    allmaJobId: ALLMA_JOB_TYPE_STEMPRUNING,
    excludeFromTypes: [ACTIONPLAN_TYPES_SCARIFICATION, ACTIONPLAN_TYPES_SCARIFICATION_WITH_EXCAVATOR, ACTIONPLAN_TYPES_PLANTSALE, ACTIONPLAN_TYPES_DITCH_CLEARING, ACTIONPLAN_TYPES_SPRAYING, ACTIONPLAN_TYPES_PRECLEARING_FELLING, ACTIONPLAN_TYPES_ADDITIVE_PLANTING, ACTIONPLAN_TYPES_FERTILIZATION],
    excludeFromReallocatedAreas: [ACTIONPLAN_REALLOCATED_AREA_REGULATED, ACTIONPLAN_REALLOCATED_AREA_BEITE, ACTIONPLAN_REALLOCATED_AREA_NATURAL, ACTIONPLAN_REALLOCATED_AREA_THINNING],
    allowedMonths: ALL_MONTHS
  }
]

const { products } = useProductService()

export const ACTIONPLAN_PRODUCT_NUMBER_STANDARD = '10114'
export const ACTIONPLAN_PRODUCT_NUMBER_SCARIFICATION = '10204'
export const ACTIONPLAN_PRODUCT_NUMBER_ADDITIVE_PLANTING = '10115'
export const getActionPlanStandardProduct = computed(() => products.value?.find((p) => p.ProductNumber === ACTIONPLAN_PRODUCT_NUMBER_STANDARD)?.Id)
export const getActionPlanProductScarification = computed(() => products.value?.find((p) => p.ProductNumber === ACTIONPLAN_PRODUCT_NUMBER_SCARIFICATION)?.Id)
export const getActionPlanProductAdditivePlanting = computed(() => products.value?.find((p) => p.ProductNumber === ACTIONPLAN_PRODUCT_NUMBER_ADDITIVE_PLANTING)?.Id)

export const ACTIONPLAN_PLANTING_TYPES_NEITHER = 0
export const ACTIONPLAN_PLANTING_TYPES_OPPORTUNITY = 1
export const ACTIONPLAN_PLANTING_TYPES_ORDER = 2

export const ACTIONPLAN_PLANTING_TYPES = [
  {
    Id: ACTIONPLAN_PLANTING_TYPES_ORDER,
    Name: 'PLANTING_ORDER',
    Short: 'OR'
  },
  {
    Id: ACTIONPLAN_PLANTING_TYPES_NEITHER,
    Name: 'PLANTING_NEITHER',
    Short: 'IA'
  }
]

export const ACTIONPLAN_FOREST_MATURE_YES = 961700000

export const ACTIONPLAN_FOREST_MATURE = [
  {
    Id: 961700000,
    Name: 'YES'
  },
  {
    Id: 961700001,
    Name: 'FOREST_MATURE_OVER_MINIMUM'
  },
  {
    Id: 961700002,
    Name: 'FOREST_MATURE_UNDER_MINIMUM'
  }
]

export const ACTIONPLAN_WOODS = [
  {
    Id: 1,
    Name: 'G'
  },
  {
    Id: 2,
    Name: 'F'
  },
  {
    Id: 3,
    Name: 'B'
  }
]

export const ACTIONPLAN_SITE_QUALITIES = [
  {
    Id: 8,
    Name: '6'
  },
  {
    Id: 7,
    Name: '8'
  },
  {
    Id: 1,
    Name: '11'
  },
  {
    Id: 2,
    Name: '14'
  },
  {
    Id: 3,
    Name: '17'
  },
  {
    Id: 4,
    Name: '20'
  },
  {
    Id: 5,
    Name: '23'
  },
  {
    Id: 6,
    Name: '26'
  }
]

export const ACTIONPLAN_MASL = [
  {
    Id: 1,
    Name: '0-150'
  },
  {
    Id: 2,
    Name: '151-250'
  },
  {
    Id: 3,
    Name: '251-350'
  },
  {
    Id: 4,
    Name: '351-450'
  },
  {
    Id: 5,
    Name: '451-550'
  },
  {
    Id: 6,
    Name: '551-650'
  },
  {
    Id: 7,
    Name: '651-750'
  },
  {
    Id: 8,
    Name: '751-850'
  },
  {
    Id: 9,
    Name: '851-950'
  }
]
